<app-default-layout [sidebar]="true">
  <div class="not-found-container">
    <div class="text-center">
      <h1>404</h1>
      <h4>Page not found!</h4>
    </div>
  </div>
</app-default-layout>
